import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import EN from './translations/en';
import AR from './translations/ar';
import { store } from '../redux/store';

export const translate = (key, config) => i18n.t(key, config);

export const getLocalizedNumber = (number, withComas = true) => {
  const result = new Intl.NumberFormat(
    store.getState().appState.language === 'ar' ? 'ar-SA' : 'en-US',
  ).format(number);
  return withComas ? result : result.replace(/,|٬/g, '');
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: EN,
      },
      ar: {
        translation: AR,
      },
    },
  });

export default i18n;
